import * as yup from 'yup';

export const validationSchema = yup.object({
  filter: yup
    .object()
    .nullable()
    .shape({
      dateFrom: yup.date().typeError('Data non valida').nullable(),
      dateTo: yup
        .date()
        .typeError('Data non valida')
        .nullable()
        .when('dateFrom', (dateFrom, formvalidationSchema) =>
          dateFrom
            ? formvalidationSchema.min(
                dateFrom,
                'La data deve essere maggiore uguale della data Dal'
              )
            : formvalidationSchema.nullable()
        ),
    }),
});
